<template>
  <v-select
    :items="doviztipi"
    :label="$t('Exchange-Rate-v2')"
    item-text="text"
    item-value="text"
    v-model="val"
  >
  </v-select>
</template>

<script>
import tool from "../tools";

export default {
  props: {
    value: {},
    kurTarihi: {},
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      doviztipi: [],
    };
  },
  created(){
    this.gunlukKurlariCek();
  },
  methods: {
    gunlukKurlariCek() {
      tool
        .http_post(this, "ParaBirimleri", {
          paraBirimi: "",
          kur: "",
          kurTarihi: "",
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            this.kurList = this.defitems;
          }
        );
    },
  },
};
</script>

<style>
</style>